import styled from "styled-components";
import { Container } from "../../common/styles";
import { theme } from "../../theme";

export const StyledSection = styled(Container)`
    margin-top: 80px;
    font-family: 'Playfair Display', serif;
    background-image:url("./background.png");
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
`;

export const PricesList = styled.ul`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(500px, 1fr));
    @media (max-width: ${theme.breakpoints.mobile}) {
        grid-template-columns: 1fr;
    }
`;

export const ListElement = styled.li`
    display: grid;
    grid-template-columns: auto 1fr auto;
    padding: 15px;
    font-size: 24px;
    @media (max-width: ${theme.breakpoints.mobile}) {
        font-size: 15px;
    }
`;

export const Dots = styled.span`
    border-bottom: 2px dotted;
    margin: 0 6px;
    color: ${theme.colors.text + "5"};
`;

export const Price = styled.span`
    font-family: 'Roboto', sans-serif;
    align-self: flex-end;
    color: ${theme.colors.red};
    font-weight: ${theme.fonts.weights.bold};
`;

export const KitBlock = styled.div`
    display: flex;
    flex-direction: column;
    align-self: flex-end;
`;

export const Kit = styled.span`
    margin-bottom: 5px;
    ::after{
        content: " +"
    }
    &:nth-last-child(1){
        ::after{
            content: none;
        }
    }
`;